import { render, staticRenderFns } from "./DialogScorte.vue?vue&type=template&id=5fd1758f&"
import script from "./DialogScorte.vue?vue&type=script&lang=js&"
export * from "./DialogScorte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports